import { Enquiry } from "../../components/Enquiry";
import { Footer } from "../../components/Footer";
import { Layout } from "../../components/Layout";
import { CTA_LINK, CTA_TEXT, DEMO_TEXT } from "@/components/layout/PageLayout";
import { Hero } from "@/components/layout/sections/Hero";
import { ProductFooter } from "@/components/layout/sections/ProductFooter";
import Section from "@/components/layout/sections/Section";
import TitleSection from "@/components/layout/text/TitleSection/TitleSection";
import { Button } from "@ui";
import { Link, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Helmet } from "react-helmet";

const integrationGrid = [
  {
    id: 1,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 123 123" height={48} width={48}>
        <path
          fill="#fff"
          d="M8.708 61.26c0 20.802 12.089 38.779 29.619 47.298L13.258 39.872a52.354 52.354 0 0 0-4.55 21.388ZM96.74 58.608c0-6.495-2.333-10.993-4.334-14.494-2.664-4.329-5.161-7.995-5.161-12.324 0-4.831 3.664-9.328 8.825-9.328.233 0 .454.029.68.042C87.4 13.938 74.945 8.708 61.263 8.708c-18.36 0-34.513 9.42-43.91 23.688 1.233.037 2.395.063 3.382.063 5.497 0 14.006-.667 14.006-.667 2.833-.167 3.167 3.994.337 4.329 0 0-2.847.335-6.015.501L48.2 93.547l11.5-34.493-8.187-22.434c-2.83-.166-5.511-.501-5.511-.501-2.832-.166-2.5-4.496.332-4.329 0 0 8.679.667 13.843.667 5.496 0 14.006-.667 14.006-.667 2.835-.167 3.168 3.994.337 4.329 0 0-2.853.335-6.015.501l18.992 56.494 5.242-17.517c2.272-7.269 4-12.49 4-16.989Z"
        />
        <path
          fill="#fff"
          d="m62.184 65.857-15.768 45.819a52.552 52.552 0 0 0 14.846 2.141c6.12 0 11.989-1.058 17.452-2.979a4.615 4.615 0 0 1-.374-.724L62.184 65.857ZM107.376 36.046c.226 1.674.354 3.47.354 5.404 0 5.333-.996 11.328-3.996 18.824l-16.053 46.413c15.624-9.111 26.133-26.038 26.133-45.426.001-9.137-2.333-17.73-6.438-25.215Z"
        />
        <path
          fill="#fff"
          d="M61.262 0C27.483 0 0 27.481 0 61.26c0 33.783 27.483 61.263 61.262 61.263 33.778 0 61.265-27.48 61.265-61.263C122.526 27.481 95.04 0 61.262 0Zm0 119.715c-32.23 0-58.453-26.223-58.453-58.455 0-32.23 26.222-58.451 58.453-58.451 32.229 0 58.45 26.221 58.45 58.451 0 32.232-26.221 58.455-58.45 58.455Z"
        />
      </svg>
    ),
    title: "Wordpress",
  },
  {
    id: 2,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 94 121" height={48} width={48}>
        <path
          fill="#fff"
          d="M66.055 25.67C57.563 17.194 49.46 9.113 47.05 0 44.64 9.113 36.536 17.194 28.046 25.67 15.31 38.381.87 52.787.87 74.393a46.068 46.068 0 0 0 3.51 17.654 46.124 46.124 0 0 0 10.01 14.969 46.195 46.195 0 0 0 32.66 13.514 46.195 46.195 0 0 0 32.66-13.514 46.124 46.124 0 0 0 10.01-14.969 46.069 46.069 0 0 0 3.511-17.654c0-21.605-14.438-36.012-27.177-48.723ZM20.499 85.14c-2.831-.097-13.282-18.086 6.105-37.24l12.83 13.996a1.094 1.094 0 0 1-.086 1.634c-3.062 3.136-16.11 16.204-17.732 20.722-.334.933-.823.897-1.117.887Zm26.553 23.708a15.903 15.903 0 0 1-11.231-4.645 15.863 15.863 0 0 1-4.652-11.217 16.516 16.516 0 0 1 3.959-10.477c2.864-3.497 11.922-13.334 11.922-13.334s8.919 9.981 11.9 13.3a15.5 15.5 0 0 1 3.984 10.511 15.85 15.85 0 0 1-4.652 11.216 15.892 15.892 0 0 1-11.23 4.646ZM77.45 83.126c-.342.748-1.119 1.996-2.167 2.034-1.868.068-2.068-.888-3.449-2.93-3.031-4.48-29.487-32.093-34.436-37.434-4.353-4.697-.613-8.009 1.122-9.744 2.176-2.178 8.529-8.518 8.529-8.518s18.943 17.949 26.833 30.213c7.89 12.264 5.172 22.877 3.568 26.379Z"
        />
      </svg>
    ),
    title: "Drupal",
  },
  {
    id: 3,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 123 123" height={48} width={48}>
        <mask id="a" width="123" height="123" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: "luminance" }}>
          <path fill="#fff" d="M122.433 0H0v123h122.433V0Z" />
        </mask>
        <g mask="url(#a)">
          <path
            fill="#fff"
            d="M58.36 89.79c4.795-.615 9.386-2.101 13.57-4.459 10.355-5.842 16.273-15.734 16.783-28.034V56.17h14.437c-.867-7.329-3.724-13.991-7.754-19.731l-14.692 9.43c4.438 7.072 5.05 14.76 1.581 22.55-3.928 9.43-13.314 17.476-23.925 21.32m45.045-31.365H90.958c-.868 12.402-7.295 22.96-17.906 28.751-6.07 3.331-12.958 5.074-19.998 5.074a46.33 46.33 0 0 1-16.273-2.973c6.428 3.947 13.57 6.201 20.967 6.201h.102c13.314 0 25.405-7.072 32.19-19.116l.612-.974 8.264 5.33a42.182 42.182 0 0 0 4.591-19.218c0-.974-.102-1.999-.102-3.075ZM57.85 97.683c-13.468 0-26.017-6.714-34.945-18.092 6.785 14.402 21.375 24.446 38.26 24.446 15.662 0 29.384-8.558 36.68-21.32l-6.53-4.1c-7.295 11.89-19.64 19.117-33.465 19.117m3.316 8.558c-24.538 0-44.535-19.987-44.535-44.74 0-24.755 19.895-44.793 44.586-44.793 24.69 0 44.535 19.987 44.535 44.741s-19.998 44.741-44.535 44.741M61.217 0C27.394 0 0 27.521 0 61.5S27.394 123 61.217 123c33.822 0 61.216-27.521 61.216-61.5S95.039 0 61.217 0Z"
          />
        </g>
      </svg>
    ),
    title: "Sitecore",
  },
  {
    id: 4,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 113 128" height={48} width={48}>
        <path
          fill="#fff"
          d="M41.128 16.58a17.389 17.389 0 0 1 4.45 17.021 35.239 35.239 0 0 1 18.158-5.025h.13a35.332 35.332 0 0 1 25.013 10.483c5.299 5.573 14.112 5.789 19.67.49 5.573-5.3 5.789-14.112.49-19.67-.13-.145-.274-.274-.418-.418A63.01 63.01 0 0 0 63.938.755h-.245a62.856 62.856 0 0 0-35.28 10.742h.389c4.622 0 9.043 1.83 12.312 5.098l.014-.014ZM98.512 85.125c-3.672 0-7.2 1.454-9.807 4.032A35.36 35.36 0 0 1 63.75 99.453h-.13a34.89 34.89 0 0 1-18.172-5.112c.417 1.512.619 3.082.619 4.651 0 9.605-7.79 17.395-17.395 17.395h-.461a62.905 62.905 0 0 0 35.309 10.916h.244a62.93 62.93 0 0 0 44.554-18.375c5.458-5.414 5.487-14.227.087-19.685a13.918 13.918 0 0 0-9.879-4.118h-.014ZM16.36 86.68a17.308 17.308 0 0 1 12.312-5.098c1.598 0 3.182.216 4.708.648a35.308 35.308 0 0 1 .072-36.533c-9.273 2.55-18.85-2.908-21.398-12.182a17.355 17.355 0 0 1-.62-4.622v-.476C-3.123 49.802-3.18 77.897 11.263 99.353v-.36c0-4.623 1.814-9.043 5.098-12.312Z"
        />
        <path
          fill="#fff"
          d="M28.83 14.58c-3.96 0-6.724 1.64-10.08 4.996-3.196 3.197-4.204 5.99-4.219 9.317 0 7.905 6.408 14.299 14.314 14.299 7.905 0 14.299-6.408 14.299-14.314 0-7.89-6.408-14.299-14.3-14.299h-.014ZM14.33 99.006c0 3.946 1.642 6.725 4.997 10.08 3.197 3.197 5.99 4.22 9.317 4.22 7.877-.029 14.241-6.423 14.212-14.3-.028-7.877-6.422-14.241-14.299-14.212-7.862.028-14.212 6.393-14.212 14.255v-.043h-.015Z"
        />
      </svg>
    ),
    title: "Contentful",
  },
  {
    id: 5,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 137 121" height={48} width={48}>
        <path fill="#fff" d="M81.26 121 71.31 93.367H46.332l20.995-52.735L99.177 121H137L86.509 0H50.857L0 121h81.26Z" />
      </svg>
    ),
    title: "Adobe Experience Manager",
  },
  {
    id: 6,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 127 124" height={48} width={48}>
        <path
          fill="#fff"
          d="M.286 61.58c0-34.104 28.157-61.5 63-61.5s63 27.396 63 61.5c0 34.105-28.157 61.501-63 61.501s-63-27.396-63-61.5ZM61.888 82.54c-6.13 0-11.155-.553-14.494-1.106-3.902-.85-6.422-3.084-8.08-6.149-1.397-3.084-2.236-8.108-1.952-14.833 0-3.617.267-6.97.535-10.347.571-3.329.839-6.129 1.418-8.388l.55-2.223v-.269c0-.556-.55-1.133-1.13-1.133l-8.079-1.11h-.268c-.55 0-1.122.557-1.39.841 0 .538-.287.826-.555 1.955-.551 2.512-.838 4.755-1.39 7.82a66.082 66.082 0 0 0-.838 10.9s-.268.84 0 7.55c.283 6.725 1.39 12.033 3.626 16.227 2.236 3.906 5.843 6.97 11.155 8.657 5.292 1.69 12.533 2.531 21.739 2.531h1.102c9.21 0 16.447-.841 21.74-2.531 5.311-1.663 8.941-4.751 11.154-8.657 2.237-4.198 3.367-9.505 3.627-16.227.287-6.71 0-7.55 0-7.55 0-3.906-.532-7.551-.839-10.88-.551-3.377-.819-5.62-1.39-7.84-.268-1.11-.268-1.686-.555-1.955 0-.552-.551-.84-1.39-.84h-.268l-8.1 1.11c-.554 0-1.106.572-1.106 1.133v.268l.552 2.24c.555 2.242.823 5.042 1.397 8.371.556 3.377.556 6.73.556 10.347 0 6.726-.556 11.48-1.953 14.833-1.39 3.084-4.178 5.304-8.08 6.149-3.359.841-8.363 1.106-14.494 1.106h-2.8Z"
        />
      </svg>
    ),
    title: "Umbraco",
  },
  {
    id: 7,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 166 65" height={48} width={48}>
        <path
          fill="#fff"
          d="M165.438.08h-9.114a7.622 7.622 0 0 0-6.312 3.353l-12.188 18.014a.819.819 0 0 1-1.354 0L124.281 3.433A7.616 7.616 0 0 0 117.97.08h-9.115l21.714 32.089-21.594 31.91h9.114a7.623 7.623 0 0 0 6.313-3.351l12.068-17.836a.819.819 0 0 1 1.354 0l12.069 17.836a7.616 7.616 0 0 0 6.311 3.352h9.114L143.725 32.17 165.438.08ZM90.1 6.627v57.454h4.357c3.61 0 6.535-2.93 6.535-6.547V.081h-4.356c-3.61 0-6.535 2.93-6.535 6.546ZM82.115.08H78.24a9.141 9.141 0 0 0-8.912 7.126L60.655 45.4l-7.59-35.652C51.66 3.157 44.912-1.286 38.007.625c-4.4 1.217-7.66 4.94-8.611 9.41l-7.513 35.316L13.227 7.21A9.148 9.148 0 0 0 4.312.08H.438l14.528 63.997h5.505a10.59 10.59 0 0 0 10.353-8.393L40.11 12.02c.115-.542.6-.934 1.151-.934.552 0 1.036.392 1.151.934l9.296 43.666a10.588 10.588 0 0 0 10.353 8.39h5.523L82.115.082Z"
        />
      </svg>
    ),
    title: "Wix",
  },
  {
    id: 8,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 124 124" height={48} width={48}>
        <path
          fill="#fff"
          d="m22.234 62.08-2.364-2.356c-7.311-7.334-9.582-17.837-6.813-27.122C5.746 30.948.287 24.378.287 16.544.286 7.446 7.627.081 16.696.081c8.166 0 14.917 5.976 16.192 13.795 8.851-2.076 18.542.343 25.448 7.272l.95.952-12.118 12.14-.933-.951a10.06 10.06 0 0 0-14.233 0c-3.951 3.964-3.936 10.362-.016 14.294l2.365 2.372 12.117 12.141L59.286 74.94 47.184 87.08 34.367 74.238 22.234 62.081Z"
        />
        <path
          fill="#fff"
          d="m36.286 48.855 12.836-12.947 12.135-12.226 2.367-2.372c7.306-7.37 17.696-9.68 26.95-6.946C91.68 6.287 98.548.081 106.851.081c9.082 0 16.434 7.416 16.434 16.577 0 8.423-6.215 15.368-14.269 16.437 2.648 9.286.343 19.705-6.916 27.027l-.95.959-12.12-12.241.935-.943c3.941-3.976 3.941-10.418 0-14.378-3.925-3.96-10.281-3.96-14.238.016l-2.368 2.388-12.134 12.225L48.39 61.081 36.286 48.855Z"
        />
        <path
          fill="#fff"
          d="M90.605 109.906c-9.367 2.876-19.969.61-27.38-6.798l-.939-.938 12.166-12.174.938.938c3.956 3.954 10.367 3.954 14.308 0 3.94-3.938 3.94-10.314-.016-14.284l-2.377-2.375L75.14 62.1 62.286 49.239l12.181-12.158 12.838 12.846 12.166 12.158 2.392 2.391c7.006 7.001 9.414 16.831 7.24 25.786 8.022 1.125 14.183 8.001 14.183 16.331 0 9.111-7.396 16.487-16.497 16.487-8.006.032-14.667-5.626-16.184-13.174Z"
        />
        <path
          fill="#fff"
          d="M86.286 75.345 73.435 88.287 61.256 100.55l-2.395 2.409c-7.028 7.085-16.952 9.478-25.969 7.242-1.675 7.384-8.25 12.879-16.092 12.879-9.125 0-16.514-7.432-16.514-16.61 0-7.856 5.416-14.437 12.71-16.17-2.3-9.1.079-19.16 7.17-26.276l.94-.944 12.193 12.248-.939.945c-3.96 3.983-3.945 10.422 0 14.406 3.976 3.999 10.394 3.983 14.339.015l2.379-2.408 12.178-12.25 12.867-12.956 12.163 12.264Z"
        />
      </svg>
    ),
    title: "Joomla",
  },
  {
    id: 9,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 111 124" height={48} width={48}>
        <path
          fill="#fff"
          fill-rule="evenodd"
          d="M.286 10.08c0-5.523 4.477-10 10-10h90c5.523 0 10 4.477 10 10v89.986c0 5.522-4.477 9.998-10 9.998H41.969l-14.936 12.331c-1.938 1.6-4.866.221-4.866-2.292v-10.039h-11.88c-5.524 0-10-4.476-10-9.998V10.079Zm21.874 8.172h48.075c10.382 0 18.8 8.416 18.8 18.797 0 8.32-5.405 15.376-12.895 17.851 8.758 1.602 15.395 9.27 15.395 18.49 0 10.381-8.417 18.797-18.8 18.797H22.16V18.252Zm39.983 16.915H39.658v11.278h22.485a5.64 5.64 0 1 0 0-11.278ZM39.658 60.23h24.358a6.267 6.267 0 1 1 0 12.532H39.658V60.23Z"
          clip-rule="evenodd"
        />
      </svg>
    ),
    title: "Storyblok",
  },
  {
    id: 10,
    image: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 122 122" height={48} width={48}>
        <path
          fill="#fff"
          d="M60.786 121.081a60.504 60.504 0 0 0 60.5-60.5 60.5 60.5 0 1 0-60.5 60.5Zm-5.672-39.704V66.252H39.99a5.658 5.658 0 0 1-5.672-5.671 5.658 5.658 0 0 1 5.672-5.672h15.125V39.784a5.658 5.658 0 0 1 5.672-5.672 5.658 5.658 0 0 1 5.672 5.672v15.125h15.125a5.658 5.658 0 0 1 5.672 5.672 5.658 5.658 0 0 1-5.672 5.671H66.458v15.125a5.658 5.658 0 0 1-5.672 5.672 5.658 5.658 0 0 1-5.672-5.672Z"
        />
      </svg>
    ),
    title: "More via API",
  },
];

const performanceFeatures = [
  {
    id: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 65" height={48} width={48}>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M50.782 57.552a6.77 6.77 0 0 0 6.77-6.77V14.218a6.77 6.77 0 0 0-13.541 0V50.78a6.77 6.77 0 0 0 6.77 6.77ZM32.5 57.552c3.74 0 6.771-3.031 6.771-6.77V29.114a6.77 6.77 0 0 0-13.541 0V50.78a6.77 6.77 0 0 0 6.77 6.771ZM14.22 57.552a6.77 6.77 0 1 0 0-13.542 6.77 6.77 0 0 0 0 13.542Z"
        />
      </svg>
    ),
    title: "Google Analytics",
    description: (
      <>
        Add tracking for Google Analytics and monitor engagement, traffic sources, and story performance.{" "}
        <a href="https://support.shorthand.com/en/articles/45-google-analytics" target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </>
    ),
  },
  {
    id: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 65" height={48} width={48}>
        <g clipPath="url(#a)">
          <path
            fill="#fff"
            d="M32.508 0a8.125 8.125 0 0 0-5.744 13.87l18.593 18.592-12.042 12.299 4.726 4.972a9.294 9.294 0 0 1 1.896 2.002l.033.03-.003.005a9.295 9.295 0 0 1 1.406 7.402l20.99-20.711c.083-.078.18-.135.265-.217.062-.062.103-.14.162-.206a8.108 8.108 0 0 0-.162-11.282L38.253 2.38A8.098 8.098 0 0 0 32.508 0Zm-9.135 5.777L2.383 26.566a8.12 8.12 0 0 0 0 11.478l20.855 20.99a9.293 9.293 0 0 1-.209-1.975 9.295 9.295 0 0 1 11.53-9.019L19.6 32.305l11.838-11.843-5.633-5.634c-2.445-2.448-3.23-5.912-2.432-9.051Zm8.948 43.344a7.941 7.941 0 0 0-5.613 13.552 7.94 7.94 0 0 0 13.554-5.614 7.94 7.94 0 0 0-7.94-7.938Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h65v65H0z" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Google Tag Manager",
    description:
      "Take full control of your analytics and tracking. Update tags, pixels, and scripts globally — and add new integrations as your marketing stack grows.",
  },
  {
    id: 3,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 79 70" height={48} width={48}>
        <path
          fill="#fff"
          d="M40 2c1.035 0 1.882.847 1.882 1.882v3.836c13.06.917 23.483 11.34 24.4 24.4h3.836c1.035 0 1.882.847 1.882 1.882a1.888 1.888 0 0 1-1.882 1.882h-3.836c-.917 13.06-11.34 23.483-24.4 24.4v3.836A1.888 1.888 0 0 1 40 66a1.888 1.888 0 0 1-1.882-1.882v-3.836c-13.06-.917-23.483-11.34-24.4-24.4H9.882A1.888 1.888 0 0 1 8 34c0-1.035.847-1.882 1.882-1.882h3.836c.917-13.06 11.34-23.483 24.4-24.4V3.882C38.118 2.847 38.965 2 40 2ZM17.494 35.882C18.4 46.86 27.153 55.6 38.118 56.506V50.94c0-1.035.847-1.882 1.882-1.882s1.882.847 1.882 1.882v5.565C52.86 55.6 61.6 46.847 62.506 35.882H56.94A1.888 1.888 0 0 1 55.06 34c0-1.035.847-1.882 1.882-1.882h5.565C61.6 21.14 52.859 12.4 41.882 11.494v5.565A1.888 1.888 0 0 1 40 18.94a1.888 1.888 0 0 1-1.882-1.882v-5.565C27.14 12.4 18.4 21.141 17.494 32.118h5.565c1.035 0 1.882.847 1.882 1.882a1.888 1.888 0 0 1-1.882 1.882h-5.565ZM40 31.177a2.823 2.823 0 1 1 0 5.646 2.823 2.823 0 0 1 0-5.646Z"
        />
      </svg>
    ),
    title: "Trackers & pixels",
    description:
      "Install Adobe Analytics, Chartbeat, Hotjar, ad measurement pixels, social media trackers, tag managers, and more to get the metrics that matter.",
  },
];

const richMediaFeatures = [
  {
    id: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80" height={48} width={48}>
        <path fill="#fff" d="M50 15H30v13.333h20V15ZM13.333 35H30v13.333h20V35h16.666v30H13.333V35Z" />
      </svg>
    ),
    title: "Unsplash",
    description:
      "Access a vast library of high-quality, royalty-free images directly within Shorthand through our Unsplash integration. ",
  },
  {
    id: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 87 70" height={48} width={48}>
        <path
          fill="#fff"
          d="M22.111 41.375v9.375h10.436a11.461 11.461 0 0 0-.944 3.75H14.556C10.388 54.5 7 51.137 7 47V9.5C7 5.363 10.388 2 14.556 2h37.777c4.168 0 7.556 3.363 7.556 7.5v11.953l-3.778.785v-5.226h-7.555v6.797a7.645 7.645 0 0 0-3.778 2.296V5.75H22.11v35.625Zm-3.778 1.875h-7.555V47c0 2.074 1.688 3.75 3.778 3.75h3.777v-7.5Zm-7.555-3.75h7.555v-9.375h-7.555V39.5Zm7.555-13.125V17h-7.555v9.375h7.555Zm0-20.625h-3.777c-2.09 0-3.778 1.676-3.778 3.75v3.75h7.555v-7.5Zm37.778 7.5V9.5c0-2.074-1.688-3.75-3.778-3.75h-3.777v7.5h7.555ZM75 26.363v25.325c0 3.597-3.353 6.562-7.556 6.562-4.202 0-7.555-2.965-7.555-6.563 0-3.597 3.353-6.562 7.555-6.562 1.382 0 2.668.316 3.778.879v-7.957l-18.889 3.902v13.489c0 3.597-3.352 6.562-7.555 6.562-4.203 0-7.556-2.965-7.556-6.563 0-3.597 3.353-6.562 7.556-6.562 1.381 0 2.668.316 3.778.879V31.05c0-.89.625-1.653 1.499-1.84l22.667-4.688a1.924 1.924 0 0 1 1.582.375c.448.352.696.891.696 1.454v.011Zm-3.778 7.852v-5.543l-18.889 3.902v5.543l18.89-3.902ZM41 55.425c0 1.126 1.228 2.813 3.778 2.813s3.778-1.687 3.778-2.812c0-1.125-1.228-2.813-3.778-2.813S41 54.301 41 55.426Zm26.444-6.562c-2.55 0-3.777 1.688-3.777 2.813 0 1.125 1.227 2.812 3.777 2.812s3.778-1.687 3.778-2.812c0-1.125-1.228-2.813-3.778-2.813Z"
        />
      </svg>
    ),
    title: "Multimedia",
    description:
      "Embed videos, podcasts, interviews, or music from YouTube, Vimeo, SoundCloud, Spotify, and more, to create engaging digital experiences.",
  },
  {
    id: 3,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80" height={48} width={48}>
        <path
          fill="#fff"
          d="M69.337 12.54c.826-.751.89-2.049.14-2.876a2.038 2.038 0 0 0-2.87-.14L45.686 28.583l-14.88-14.911a2.01 2.01 0 0 0-2.628-.204L5.833 29.753a2.05 2.05 0 0 0-.445 2.85 2.028 2.028 0 0 0 2.844.445l20.936-15.267 15.019 15.051a2.03 2.03 0 0 0 2.806.064l22.344-20.357ZM31.402 35.465a2.04 2.04 0 0 0-2.031-2.036 2.04 2.04 0 0 0-2.031 2.036v28.498A2.04 2.04 0 0 0 29.37 66a2.04 2.04 0 0 0 2.032-2.036V35.466Zm32.502 0a2.04 2.04 0 0 0-2.032-2.036 2.04 2.04 0 0 0-2.031 2.036v28.498A2.04 2.04 0 0 0 61.872 66a2.04 2.04 0 0 0 2.032-2.036V35.466Zm-16.251 8.142a2.04 2.04 0 0 0-2.032-2.035 2.04 2.04 0 0 0-2.03 2.035v20.356A2.04 2.04 0 0 0 45.62 66a2.04 2.04 0 0 0 2.032-2.036V43.608ZM15.15 47.68a2.04 2.04 0 0 0-2.03-2.035 2.04 2.04 0 0 0-2.032 2.035v16.285A2.04 2.04 0 0 0 13.12 66a2.04 2.04 0 0 0 2.032-2.036V47.68Z"
        />
      </svg>
    ),
    title: "Data visualisation",
    description:
      "Add interactive charts, infographics, and dashboards to make your data come alive with Tableau, Flourish, Datawrapper, Typeform, and more.",
  },
];

const engagementFeatures = [
  {
    id: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 70 80" height={48} width={48}>
        <path
          fill="#fff"
          d="M21.571 55.75v11.607H49.43V11.643H21.57V55.75Zm-4.642 2.321H7.643v4.643a4.638 4.638 0 0 0 4.643 4.643h4.643v-9.286Zm0-4.642V41.82H7.643V53.43h9.286Zm0-16.25V25.57H7.643V37.18h9.286Zm0-16.25v-9.286h-4.643a4.638 4.638 0 0 0-4.643 4.643v4.643h9.286Zm37.142 32.5h9.286V41.82h-9.286V53.43Zm0-16.25h9.286V25.57h-9.286V37.18Zm0-16.25h9.286v-4.643a4.638 4.638 0 0 0-4.643-4.643h-4.643v9.286Zm0 37.142v9.286h4.643a4.638 4.638 0 0 0 4.643-4.643v-4.643h-9.286ZM12.286 7h46.428C63.836 7 68 11.164 68 16.286v46.428C68 67.836 63.836 72 58.714 72H12.286C7.164 72 3 67.836 3 62.714V16.286C3 11.164 7.164 7 12.286 7Z"
        />
      </svg>
    ),
    title: "Social asset generator",
    description: "Transform your published story into an eye-catching, scroll-through video—perfectly formatted for social media.",
  },
  {
    id: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 61 70" height={48} width={48}>
        <g clipPath="url(#a)">
          <path
            fill="#fff"
            d="M7.286 6.643a4.638 4.638 0 0 0-4.643 4.643v46.428a4.638 4.638 0 0 0 4.643 4.643h46.428a4.638 4.638 0 0 0 4.643-4.643V11.286a4.638 4.638 0 0 0-4.643-4.643H7.286ZM-2 11.286C-2 6.164 2.164 2 7.286 2h46.428C58.836 2 63 6.164 63 11.286v46.428C63 62.836 58.836 67 53.714 67H7.286C2.164 67-2 62.836-2 57.714V11.286Zm41.786 13.928a4.643 4.643 0 1 0 0-9.285 4.643 4.643 0 0 0 0 9.285Zm0 4.643a9.226 9.226 0 0 1-6.515-2.67L25.48 31.86c.247.842.377 1.727.377 2.641 0 .914-.13 1.8-.377 2.64l7.791 4.672a9.252 9.252 0 0 1 6.515-2.67c5.121 0 9.285 4.165 9.285 9.287 0 5.121-4.164 9.285-9.285 9.285-5.122 0-9.286-4.164-9.286-9.285 0-.915.13-1.8.377-2.641l-7.791-4.672a9.251 9.251 0 0 1-6.515 2.67c-5.121 0-9.285-4.164-9.285-9.286s4.164-9.286 9.285-9.286a9.226 9.226 0 0 1 6.515 2.67l7.791-4.672a9.371 9.371 0 0 1-.377-2.64c0-5.122 4.164-9.286 9.286-9.286 5.121 0 9.285 4.164 9.285 9.285 0 5.122-4.164 9.286-9.285 9.286Zm0 23.214a4.643 4.643 0 1 0 0-9.285 4.643 4.643 0 0 0 0 9.285ZM21.214 34.5a4.643 4.643 0 1 0-9.285 0 4.643 4.643 0 0 0 9.285 0Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h61v70H0z" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Sharing buttons",
    description:
      "Insert sharing buttons directly into your story. Make it effortless for readers to post on social and help your story get reach.",
  },
  {
    id: 3,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 79 70" height={48} width={48}>
        <path
          fill="#fff"
          d="M37.251 39.41 66.38 10.267 47.483 63.047a.342.342 0 0 1-.316.222.316.316 0 0 1-.304-.21L37.251 39.41ZM63.737 7.624 34.608 36.768l-23.656-9.614a.328.328 0 0 1-.21-.304c0-.14.093-.269.222-.316l52.773-18.91ZM9.55 30.616l24.066 9.777 9.775 24.07A4.074 4.074 0 0 0 47.167 67a4.073 4.073 0 0 0 3.836-2.702L71.817 6.196a3.145 3.145 0 0 0-.736-3.274 3.116 3.116 0 0 0-3.275-.737L9.701 23.003A4.073 4.073 0 0 0 7 26.838a4.074 4.074 0 0 0 2.537 3.778h.012Z"
        />
      </svg>
    ),
    title: "Email marketing",
    description: "Turn readers into loyal subscribers with embedded signup forms for HubSpot, Mailchimp, Campaign Monitor, and more.",
  },
];

const notificationFeatures = [
  {
    id: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 61 70" height={48} width={48}>
        <path
          fill="#fff"
          d="M30.5 2a2.04 2.04 0 0 0-2.036 2.031v2.133C18.171 7.18 10.143 15.838 10.143 26.375v1.308c0 5.725-1.96 11.286-5.535 15.755l-1.285 1.6A6.04 6.04 0 0 0 2 48.794a6.02 6.02 0 0 0 6.03 6.017h44.94A6.02 6.02 0 0 0 59 48.795c0-1.371-.47-2.692-1.323-3.758l-1.285-1.6a25.162 25.162 0 0 1-5.535-15.754v-1.308c0-10.537-8.028-19.195-18.321-20.21V4.03A2.04 2.04 0 0 0 30.5 2Zm0 8.125c8.995 0 16.286 7.274 16.286 16.25v1.308a29.185 29.185 0 0 0 6.438 18.294l1.272 1.6c.28.342.433.774.433 1.218 0 1.079-.878 1.955-1.96 1.955H8.031a1.958 1.958 0 0 1-1.96-1.955c0-.444.153-.876.433-1.219l1.285-1.6a29.248 29.248 0 0 0 6.425-18.293v-1.308c0-8.976 7.29-16.25 16.286-16.25Zm-8.64 50.781A9.165 9.165 0 0 0 30.5 67c3.982 0 7.38-2.54 8.64-6.094H34.57a5.088 5.088 0 0 1-4.071 2.032c-1.667 0-3.143-.8-4.071-2.032H21.86Z"
        />
      </svg>
    ),
    title: "Email notifications",
    description: "Bring teammates into the conversation with threaded in-app Shorthand discussions and email notifications.",
  },
  {
    id: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 70 70" height={48} width={48}>
        <path
          fill="#fff"
          d="M63.578 34.5a9.096 9.096 0 1 0-11.18-14.159v-9.239A9.097 9.097 0 0 0 35.5 6.422a9.096 9.096 0 1 0-14.159 11.18h-9.239A9.097 9.097 0 0 0 7.422 34.5a9.096 9.096 0 1 0 11.18 14.158v9.24a9.096 9.096 0 0 0 16.898 4.68 9.095 9.095 0 1 0 14.158-11.18h9.24a9.097 9.097 0 0 0 4.68-16.898Zm-4.68-14.299a6.5 6.5 0 1 1 0 13h-6.5v-6.5a6.507 6.507 0 0 1 6.5-6.5Zm-9.24 13 .14-.14v.14h-.14ZM43.3 4.602a6.506 6.506 0 0 1 6.5 6.5V26.7a6.506 6.506 0 0 1-6.5 6.5h-6.5V11.101a6.507 6.507 0 0 1 6.5-6.499Zm-6.5 44.055.14.14h-.14v-.14ZM34.2 20.341a10.26 10.26 0 0 0-.14-.14h.14v.14Zm-12.999-9.239a6.5 6.5 0 0 1 13 0v6.5h-6.5a6.507 6.507 0 0 1-6.5-6.5ZM5.603 26.701a6.506 6.506 0 0 1 6.5-6.5H27.7a6.507 6.507 0 0 1 6.5 6.5v6.5H12.101a6.506 6.506 0 0 1-6.499-6.5ZM21.342 35.8a9.233 9.233 0 0 0-.14.14v-.14h.14Zm-9.24 12.998a6.5 6.5 0 0 1 0-12.998h6.5v6.5a6.506 6.506 0 0 1-6.5 6.498Zm15.599 15.599a6.507 6.507 0 0 1-6.5-6.5V42.3a6.506 6.506 0 0 1 6.5-6.5h6.5v22.099a6.507 6.507 0 0 1-6.5 6.499Zm22.097-6.5a6.5 6.5 0 1 1-12.998 0v-6.499h6.5a6.506 6.506 0 0 1 6.498 6.5Zm9.1-9.099H43.298a6.507 6.507 0 0 1-6.5-6.499v-6.5h22.098a6.499 6.499 0 1 1 0 13Z"
        />
      </svg>
    ),
    title: "Slack",
    description: "Send notifications directly to a Slack channel when new content is ready.",
  },
  {
    id: 3,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 78 78" height={48} width={48}>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M71.604 22.628a5.177 5.177 0 1 1-10.355 0 5.177 5.177 0 0 1 10.355 0Z"
        />
        <mask id="a" width="20" height="30" x="55" y="32" maskUnits="userSpaceOnUse" style={{ maskType: "luminance" }}>
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M57.064 58.458a10.516 10.516 0 0 0 7.071 2.716h.05c5.83 0 10.556-4.725 10.556-10.555V35.326a2.872 2.872 0 0 0-2.872-2.872H55.115a2.842 2.842 0 0 1 2.77 2.906v17.443a17.024 17.024 0 0 1-.82 5.655Z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#a)">
          <path
            fill="#fff"
            d="m57.064 58.458-3.091-1.002-.65 2.003 1.564 1.412 2.177-2.413Zm-1.949-26.004v-3.25l-.08 6.499.08-3.25Zm2.77 2.906-3.248-.075-.001.038v.037h3.25Zm0 17.443h-3.25v.038l.002.038 3.249-.076Zm6.25 5.121a7.266 7.266 0 0 1-4.893-1.879l-4.355 4.826a13.766 13.766 0 0 0 9.249 3.553l-.001-6.5Zm.05 0h-.05v6.5h.05v-6.5Zm7.306-7.305a7.306 7.306 0 0 1-7.306 7.305v6.5c7.625 0 13.806-6.18 13.806-13.805h-6.5Zm0-15.293v15.293h6.5V35.326h-6.5Zm.378.377a.378.378 0 0 1-.378-.377h6.5a6.122 6.122 0 0 0-6.122-6.122v6.5Zm-16.754 0H71.87v-6.5H55.115v6.5Zm6.02-.267a6.092 6.092 0 0 0-5.94-6.231l-.16 6.498a.408.408 0 0 1-.398-.418l6.498.15Zm0 17.367V35.36h-6.5v17.443h6.5Zm-.979 6.657a20.267 20.267 0 0 0 .979-6.732l-6.498.15c.037 1.604-.2 3.143-.664 4.578l6.183 2.004Z"
          />
        </g>
        <mask id="b" width="21" height="21" x="35" y="9" maskUnits="userSpaceOnUse" style={{ maskType: "luminance" }}>
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M51.839 19.576a6.575 6.575 0 0 1-8.874 6.162c.02.136.03.275.03.417v2.983a9.852 9.852 0 0 0 2.268.263c5.427 0 9.826-4.399 9.826-9.825 0-5.427-4.4-9.826-9.826-9.826s-9.825 4.4-9.825 9.826c0 1.35.272 2.637.765 3.808h3.699a6.576 6.576 0 1 1 11.937-3.808Z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill="#fff"
            d="m42.964 25.738 1.137-3.045a3.25 3.25 0 0 0-4.35 3.53l3.213-.485Zm.032 3.4h-3.25a3.25 3.25 0 0 0 2.502 3.163l.748-3.163Zm-6.793-5.754-2.996 1.26a3.25 3.25 0 0 0 2.996 1.99v-3.25Zm3.699 0v3.25A3.25 3.25 0 0 0 42.55 21.5l-2.648 1.884Zm5.361 6.017c5.427 0 9.826-4.399 9.826-9.825h-6.5a3.326 3.326 0 0 1-3.326 3.325v6.5Zm-3.434-.618a9.81 9.81 0 0 0 3.434.618v-6.5c-.415 0-.805-.074-1.162-.208l-2.273 6.09Zm-2.078-2.56a.458.458 0 0 1-.005-.068h6.5c0-.305-.023-.606-.068-.901l-6.427.969Zm-.005-.068v2.983h6.5v-2.983h-6.5Zm5.517-.004a6.605 6.605 0 0 1-1.52-.176l-1.495 6.326c.971.23 1.981.35 3.015.35v-6.5Zm6.576-6.575a6.575 6.575 0 0 1-6.576 6.575v6.5c7.222 0 13.076-5.854 13.076-13.075h-6.5ZM45.263 13a6.575 6.575 0 0 1 6.576 6.576h6.5c0-7.222-5.854-13.076-13.076-13.076V13Zm-6.576 6.576A6.576 6.576 0 0 1 45.263 13V6.5c-7.221 0-13.075 5.854-13.075 13.076h6.5Zm.511 2.547a6.544 6.544 0 0 1-.51-2.547h-6.5c0 1.79.361 3.505 1.02 5.069l5.99-2.522Zm-2.995 4.51h3.699v-6.5h-3.7v6.5Zm-.766-7.057c0 2.116.673 4.086 1.817 5.692L42.55 21.5a3.295 3.295 0 0 1-.613-1.924h-6.5Zm9.826-9.826c-5.426 0-9.826 4.4-9.826 9.826h6.5a3.326 3.326 0 0 1 3.326-3.326v-6.5Zm9.826 9.826c0-5.427-4.4-9.826-9.826-9.826v6.5a3.325 3.325 0 0 1 3.326 3.326h6.5Z"
          />
        </g>
        <mask id="c" width="34" height="39" x="28" y="32" maskUnits="userSpaceOnUse" style={{ maskType: "luminance" }}>
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M28.222 56.64c1.559 7.604 8.195 13.406 16.285 13.604 9.406-.23 16.847-8.035 16.628-17.44V35.36a2.842 2.842 0 0 0-2.77-2.906h-15.37v21.415a2.77 2.77 0 0 1-2.77 2.77H28.222Z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill="#fff"
            d="M28.222 56.64v-3.25a3.25 3.25 0 0 0-3.184 3.903l3.184-.653Zm16.285 13.604-.08 3.25h.16l-.08-3.25Zm16.628-17.44h-3.25l.001.075 3.25-.076Zm0-17.444-3.249-.075v.075h3.25Zm-2.77-2.906.08-3.25h-.08v3.25Zm-15.37 0v-3.25a3.25 3.25 0 0 0-3.25 3.25h3.25Zm-2.77 24.186v-3.25h-.013l.013 3.25Zm0 0v3.25h.012l-.012-3.25Zm-15.187.653c1.856 9.054 9.754 15.965 19.39 16.2l.159-6.498c-6.544-.16-11.92-4.854-13.182-11.008l-6.367 1.306Zm19.549 16.2c11.198-.274 20.058-9.567 19.797-20.765l-6.498.15c.177 7.614-5.845 13.931-13.458 14.117l.159 6.498Zm19.798-20.69V35.36h-6.5v17.443h6.5Zm0-17.367a6.092 6.092 0 0 0-5.94-6.231l-.16 6.498a.408.408 0 0 1-.399-.418l6.498.15Zm-6.02-6.232h-15.37v6.5h15.37v-6.5Zm-18.62 3.25v21.415h6.5V32.454h-6.5Zm0 21.415a.48.48 0 0 1 .48-.48v6.5a6.021 6.021 0 0 0 6.02-6.02h-6.5Zm.48-.48H28.222v6.5h12.002v-6.5Z"
          />
        </g>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M40.225 21.759H12.511a4.396 4.396 0 0 0-4.396 4.396v27.714a4.396 4.396 0 0 0 4.396 4.396h27.714a4.396 4.396 0 0 0 4.396-4.396V26.155a4.396 4.396 0 0 0-4.396-4.396ZM18.855 33.072h7.312m0 0v16.25m0-16.25h7.312"
        />
      </svg>
    ),
    title: "Microsoft Teams",
    description: "Let your team know when there’s an update on a story — right in Teams.",
  },
];

const FeaturesIntegrations: React.FC<{ location: any }> = props => {
  const [showPortal, setShowPortal] = React.useState(false);
  const prePopulatedFields = React.useRef<Record<any, string>>({});

  function handleShowPortal(fields?: Record<any, string>): void {
    setShowPortal(true);
    prePopulatedFields.current = fields || {};
  }

  const portalProps = {
    type: "general-enquiry",
    subject: "general-enquiry",
    prePopulatedFields: prePopulatedFields.current,
    onClose: () => {
      setShowPortal(false);
      prePopulatedFields.current = {};
    },
  };

  return (
    <Layout location={props.location} theme="dark-theme">
      {showPortal && ReactDOM.createPortal(<Enquiry {...portalProps} />, document.getElementById("modal"))}
      <div id="main" className="marketing-content container-fluid">
        <Helmet
          bodyAttributes={{
            class: "body-shorthand body-marketing body-marketing-secondary body-marketing-features body-light hide-elevio",
          }}
        ></Helmet>
        <Hero
          title={
            <>
              Integrate your <span className="tw-font-PassengerSerif tw-italic">workflow</span> seamlessly
            </>
          }
          description="Connect the tools your team loves with Shorthand. From content creation to collaboration, publication, and performance, streamline your workflow and optimise results."
          image={
            <StaticImage
              src={`../../../static/product/integrations/integrations-hero.png`}
              alt="Mind map style illustration showing different apps and tools connected to Shorthand"
              width={2432}
              height={1442}
              className="tw-w-[76rem] tw-rounded-md tw-bg-white/5 tw-shadow-2xl tw-ring-1 tw-ring-white/10"
            />
          }
          actions={
            <>
              <Button asChild variant="primary-gradient" size="lg">
                <a href={CTA_LINK} className="tw-no-underline hover:tw-no-underline">
                  {CTA_TEXT}
                </a>
              </Button>
              <Button
                variant="secondary-outline"
                style={{ border: "1px solid white" }}
                size="lg"
                onClick={() =>
                  handleShowPortal({
                    interestedIn: "demo",
                    message: "booking a demo of the Shorthand platform",
                  })
                }
              >
                {DEMO_TEXT}
              </Button>
            </>
          }
        />

        <Section>
          <TitleSection
            title="Publish seamlessly to your site or CMS"
            description={
              <>
                Shorthand integrates seamlessly with your website or CMS, letting you craft immersive, on-brand stories without
                changing your workflows. Publish to your domain or embed in existing pages — the simplest way to elevate storytelling
                without a tech overhaul.{" "}
                <a href="https://support.shorthand.com/en/articles/56-publishing-options" target="_blank" rel="noopener noreferrer">
                  Learn more.
                </a>
              </>
            }
          />
          <div className="tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-5">
            {integrationGrid.map(feature => (
              <div
                className="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-4 tw-rounded-2xl tw-bg-grey_scale-800/50 tw-p-8"
                key={`integration-item-${feature.id}`}
              >
                <div className="tw-flex tw-h-16 tw-w-full tw-items-center tw-justify-center">
                  <h3 className="tw-text-center !tw-text-lg tw-font-semibold tw-tracking-tight tw-text-brand_scale-400">
                    {feature.title}
                  </h3>
                </div>
                <div className="tw-h-12 tw-w-12">{feature.image}</div>
              </div>
            ))}
          </div>
        </Section>

        <Section>
          <TitleSection
            title="Track performance and audience insights"
            description="Understand how your stories perform with ease. Integrate your favourite analytics and tracking tools to gain deeper insights into audience behaviour."
          />
          <div className="tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-3">
            {performanceFeatures.map(feature => (
              <div
                className="tw-flex tw-flex-col tw-justify-start tw-gap-4 tw-rounded-2xl tw-bg-grey_scale-800/50 tw-p-8"
                key={`preview-feature-${feature.id}`}
              >
                <div className="tw-h-12 tw-w-12">{feature.icon}</div>
                <h3 className="!tw-text-lg tw-font-semibold tw-tracking-tight tw-text-brand_scale-400">{feature.title}</h3>
                <span className="tw-max-w-[30ch] tw-text-base/6 tw-text-[var(--foreground-color)]">{feature.description}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section>
          <TitleSection
            title="Bring stories to life with rich media"
            description="Bring in the best. Whether you're adding stunning imagery or embedding from your favourite platforms, you can create engaging, dynamic experiences — without ever leaving Shorthand."
          />
          <div className="tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-3">
            {richMediaFeatures.map(feature => (
              <div
                className="tw-flex tw-flex-col tw-justify-start tw-gap-4 tw-rounded-2xl tw-bg-grey_scale-800/50 tw-p-8"
                key={`preview-feature-${feature.id}`}
              >
                <div className="tw-h-12 tw-w-12">{feature.icon}</div>
                <h3 className="!tw-text-lg tw-font-semibold tw-tracking-tight tw-text-brand_scale-400">{feature.title}</h3>
                <span className="tw-max-w-[30ch] tw-text-base/6 tw-text-[var(--foreground-color)]">{feature.description}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section>
          <TitleSection
            title="Maximise reach and engagement"
            description="Share your stories where your audience lives. Distribute content directly to your marketing and social platforms, helping you connect with audiences and drive greater impact."
          />
          <div className="tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-3">
            {engagementFeatures.map(feature => (
              <div
                className="tw-flex tw-flex-col tw-justify-start tw-gap-4 tw-rounded-2xl tw-bg-grey_scale-800/50 tw-p-8"
                key={`preview-feature-${feature.id}`}
              >
                <div className="tw-h-12 tw-w-12">{feature.icon}</div>
                <h3 className="!tw-text-lg tw-font-semibold tw-tracking-tight tw-text-brand_scale-400">{feature.title}</h3>
                <span className="tw-max-w-[30ch] tw-text-base/6 tw-text-[var(--foreground-color)]">{feature.description}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section>
          <TitleSection
            title="Keep your team in the loop"
            description="Stay up to date in the tools your team already uses with instant updates when fresh content is published."
          />
          <div className="tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-3">
            {notificationFeatures.map(feature => (
              <div
                className="tw-flex tw-flex-col tw-justify-start tw-gap-4 tw-rounded-2xl tw-bg-grey_scale-800/50 tw-p-8"
                key={`preview-feature-${feature.id}`}
              >
                <div className="tw-h-12 tw-w-12">{feature.icon}</div>
                <h3 className="!tw-text-lg tw-font-semibold tw-tracking-tight tw-text-brand_scale-400">{feature.title}</h3>
                <span className="tw-max-w-[30ch] tw-text-base/6 tw-text-[var(--foreground-color)]">{feature.description}</span>
              </div>
            ))}
          </div>
        </Section>

        <ProductFooter />
        <Footer className="mt-0" />
      </div>
    </Layout>
  );
};

export default FeaturesIntegrations;

export const query = graphql`
  query FeaturesIntegrationsQuery {
    site {
      siteMetadata {
        name
        title
        tagline
        description
      }
    }
  }
`;
